import React, { useEffect, useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import BackButton from "../../../../designUtils/Logo/BackButton.svg";
import AmazonProductListingSummaryBar from "./Components/AmazonProductListingSummaryBar";
import AmazonProductListingTabs from "./Components/AmazonProductListingTabs";
import AmazonProductListingGroupSection from "./Components/AmazonProductListingGroupSection";
import AmazonProductListingPreview from "./Components/AmazonProductListingPreview";
import CustomModal from "../../../Components/Modals/CustomModal"; 
import fetchProductListingDataService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchProductListingDataService";
import patchListingFieldsService from "../../../../Service/OPSServices/AmazonProductListing_v1/patchListingFieldsService";
import AmazonProductListingUpdatePopup from "./Components/AmazonProductListingUpdatePopup";
import fetchProductListingHistoryDataService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchProductListingHistoryDataService";
import ReactTable from 'react-table';

function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function getCounts(fields) {
  fields = fields || [];
  return {
    errors: fields.filter(f => get(f, "validation.status", "") === "ERROR").length,
    warnings: fields.filter(f => get(f, "validation.status", "") === "WARNING").length,
    mandatory: fields.filter(f => get(f, "schema.is_mandatory", false)).length,
    basic: fields.filter(f => f && f.group === "basic").length,
    other: fields.filter(f => f && f.group === "other").length,
  };
}

function AmazonProductListingMainPage(props) {
  const { token, asin: selectedAsin, storeDetails, onBack } = props;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [search, setSearch] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const [fields, setFields] = useState([]);
  const [previewMode, setPreviewMode] = useState(false);
  const [changedFields, setChangedFields] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveModalData, setSaveModalData] = useState(null);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [errorFields, setErrorFields] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [expandedJson, setExpandedJson] = useState({});

  const toggleJsonExpand = (key) => {
    setExpandedJson((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    if (!selectedAsin) return;
    setLoading(true);
    const requestData = { asin: selectedAsin };
  
    fetchProductListingDataService(token, requestData).then((res) => {
        if (res.status =='READY') {
          console.log(res);
          setData(res);
          setFields(res.fields);
          setLoading(false);
          props.setSummaryData(res.store.summaryList)
        }
        else{
          setLoading(false);
        }


      }).catch((err) => {
        console.error(err);
        setError("Failed to load listing data.");
        setLoading(false);
      }); 

      const handleWindowScroll = () => {
        if (window.scrollY > 250) setIsScrolled(true);
        else if (window.scrollY < 50) setIsScrolled(false);
      };
      window.addEventListener("scroll", handleWindowScroll);
      return () => window.removeEventListener("scroll", handleWindowScroll);
  }, [token, selectedAsin, storeDetails]); 


  useEffect(() => {
    if (data && data.propertyGroups && data.propertyGroups.length > 0) {
      setActiveTab("pg_" + data.propertyGroups[0].key);
    }
  }, [data]);

  const handlePreviewMode = (e) => setPreviewMode(e.target.checked);

  const isListingValid = saveModalData && saveModalData.type !== "WARNING" && (!saveModalData.issues || saveModalData.issues.length === 0);

  const ORDER = [
    "Product Details",
    "Product Identity",
    "Variations",
    "Offer",
    "Images",
    "Shipping",
    "Safety & Compliance"
  ];
  
  const tabs = useMemo(() => {
    const pg = (data && data.propertyGroups) || [];
  
    return pg
      .sort((a, b) => {
        const indexA = ORDER.indexOf(a.label);
        const indexB = ORDER.indexOf(b.label);
  
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
  
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
  
        return 0;
      })
      .map(pgItem => ({
        key: "pg_" + pgItem.key,
        label: pgItem.label,
        count: fields.filter(f =>
          get(f, "ui.subcategory", "") === pgItem.label
        ).length
      }));
  
  }, [fields, data]);


const filtered = useMemo(() => {
  const pg = (data && data.propertyGroups) || [];

  return (fields || []).filter(function(f) {
    let inTab = false;

    if (previewMode) {
      inTab = true; 
    } else if (activeTab.startsWith("pg_")) {
      const pgKey = activeTab.slice(3);
      const pgItem = pg.find(p => p.key === pgKey);

      inTab = pgItem
        ? get(f, "ui.subcategory", "") === pgItem.label
        : false;
    }

    return inTab && (
      !search || (f.label || "").toLowerCase().includes(search.toLowerCase())
    );
  });

}, [fields, activeTab, search, data, previewMode]); 

var grouped = useMemo(() => {
  var map = {};
  const fieldsToGroup = previewMode ? fields : filtered;
  
  fieldsToGroup && fieldsToGroup.forEach(f => {
    var key = get(f, "ui.subcategory", "Other") || "Other";
    if (!map[key]) map[key] = [];
    map[key].push(f);
  });
  return map;
}, [filtered, fields, previewMode]);

  const handleFieldChange = useCallback((update) => {
    setChangedFields(prev => ({ ...prev, [update.field]: update }));
    setErrorFields(prevErrors => prevErrors.filter(f => f !== update.field));
  }, []);
  
  const handleHistory = () =>{
    const requestData = { asin: selectedAsin };
    fetchProductListingHistoryDataService(token, requestData).then((res) => {
        if (res) {
          console.log(res);
          setHistoryData(res.history);
          setIsHistoryModalOpen(true);
        }

      }).catch((err) => {
        console.error(err);
        setError("Failed to load listing history data.");
      }); 

  }
  const handleSave = useCallback(async () => {
    setSaving(true);
    const updates = Object.values(changedFields);
  
    if (updates.length === 0) {
      setSaveModalData({ type: "WARNING", message: "Not Updated! No fields were changed." });
      setIsSaveModalOpen(true);
      setSaving(false); 
      return;
    }
  
    const requestData = {
      asin: selectedAsin,
      mode: "VALIDATION_PREVIEW",
      updates: updates
    };
  
    const res = await patchListingFieldsService(token, requestData);
  
    if (res) {
      setSaveModalData(res);
      setIsSaveModalOpen(true);

      if (res.issues && res.issues.length > 0) {
        const errored = res.issues.map(i => i.field || i.attributeName).filter(Boolean);
        setErrorFields(errored.length > 0 ? errored : updates.map(u => u.field));
      } else {
        setErrorFields([]);
        setChangedFields({});
      }
    }
    setSaving(false); 
  }, [changedFields, selectedAsin, token]);

  var handleAutoFix = useCallback(() => { alert("Auto Fix triggered"); }, []);

  if (loading) return <div className="listing-page-loading mt-5 text-center">Loading listing data&hellip;</div>;
  if (error) return <div className="listing-page-error mt-5 text-center text-danger">{error}</div>;

  var displayAsin = (data && data.asin) || selectedAsin || "\u2014";
  var sku = (data && data.sku) || "\u2014";
  var productType = (data && data.productType) || "\u2014";

  const renderInputOutputJSON = (data, isRoot = true) => {
    if (data === null || data === undefined) return "-";
    
    if (typeof data !== "object") return <span>{String(data)}</span>;

    const ulStyle = isRoot
      ? { listStyleType: "none", padding: 0, margin: 0, fontSize: "11px", textAlign: "left" }
      : { listStyleType: "none", paddingLeft: "12px", margin: 0 };

    if (Array.isArray(data)) {
      return (
        <ul style={ulStyle}>
          {data.map((item, index) => (
            <li key={index} style={{ marginBottom: "4px" }}>
              {renderInputOutputJSON(item, false)}
            </li>
          ))}
        </ul>
      );
    }

    return (
      <ul style={ulStyle}>
        {Object.entries(data).map(([key, value]) => (
          <li key={key} style={{ marginBottom: "2px", wordBreak: "break-word" }}>
            <span style={{ fontWeight: "600", color: "#333" }}>{key} : </span> 
            {renderInputOutputJSON(value, false)}
          </li>
        ))}
      </ul>
    );
  };

  const historyColumns = [
    {
      Header: "Integer ID",
      accessor: "integerId",
      width: 150,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0 text-muted">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "ASIN",
      accessor: "asin",
      width: 120,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Mode",
      accessor: "mode",
      width: 150,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Input JSON",
      accessor: "inputJson",
      Cell: (cellInfo) => {
        const cellKey = `input-${cellInfo.index}`;
        const isExpanded = expandedJson[cellKey];
        const showButton = cellInfo.value && JSON.stringify(cellInfo.value).length > 80;

        return (
          <div className="d-flex flex-column justify-content-start w-100 text-left">
            <div style={{ maxHeight: isExpanded ? "none" : "85px", overflow: "hidden" }}>
              {cellInfo.value ? renderInputOutputJSON(cellInfo.value) : "-"}
            </div>
            {showButton && (
              <span
                onClick={() => toggleJsonExpand(cellKey)}
                style={{ color: "#3D85C6", cursor: "pointer", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}
              >
                {isExpanded ? "Read Less" : "...Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Output JSON",
      accessor: "outputJson",
      Cell: (cellInfo) => {
        const cellKey = `output-${cellInfo.index}`;
        const isExpanded = expandedJson[cellKey];
        const showButton = cellInfo.value && JSON.stringify(cellInfo.value).length > 80;

        return (
          <div className="d-flex flex-column justify-content-start w-100 text-left">
            <div style={{ maxHeight: isExpanded ? "none" : "85px", overflow: "hidden" }}>
              {cellInfo.value ? renderInputOutputJSON(cellInfo.value) : "-"}
            </div>
            {showButton && (
              <span
                onClick={() => toggleJsonExpand(cellKey)}
                style={{ color: "#3D85C6", cursor: "pointer", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}
              >
                {isExpanded ? "Read Less" : "...Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      width: 100,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className={`m-0 fw-bold ${cellInfo.value === 'VALID' ? 'text-success' : 'text-danger'}`}>
            {cellInfo.value || "-"}
          </p>
        </div>
      )
    },
    {
      Header: "Updated On",
      accessor: "updatedOn",
      width: 160,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    }
  ];

  const formatValue = (val) => {
    if (!val) return "";
  
    // If array
    if (Array.isArray(val)) {
      return val
        .map(item => {
          // If object with value key (MOST IMPORTANT CASE)
          if (typeof item === "object" && item.value !== undefined) {
            return item.value;
          }
  
          // If dimension type object
          if (typeof item === "object") {
            return Object.entries(item)
              .map(([k, v]) => {
                if (v && v.value !== undefined) {
                  return `${k}: ${v.value} ${v.unit || ""}`;
                }
                return `${k}: ${v}`;
              })
              .join(" | ");
          }
  
          return item;
        })
        .join(" | ");
    }
  
    // If object
    if (typeof val === "object") {
      return Object.entries(val)
        .map(([k, v]) => {
          if (v && v.value !== undefined) {
            return `${k}: ${v.value} ${v.unit || ""}`;
          }
          return `${k}: ${v}`;
        })
        .join(" | ");
    }
  
    return val;
  };

  const handleDownload = () => {
    if (!fields || fields.length === 0) return;
  
    const header = ["Field", "Catalog", "Listing"];
  
    const rows = fields.map(f => [
      f.label || f.field,
      formatValue(f.catalog && f.catalog.value),
      formatValue(f.listing && f.listing.value)
    ]);
  
    const csvContent =
      [header, ...rows]
        .map(row =>
          row.map(val => {
            if (!val) return '""';

            const cleaned = String(val)
              .replace(/"/g, '""')      // escape quotes
              .replace(/\n/g, " ")      // remove new lines
              .replace(/\r/g, " ");

            return `"${cleaned}"`;      // wrap in quotes
          }).join(",")
        )
        .join("\n");
  
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const today = new Date().toISOString().split("T")[0];
    link.download = `Amazon_Listing_Catalog_${selectedAsin}_${today}.csv`;
    link.click();
  };
  return (
    <div className="listing-container">
      <div className='sticky-header-container'>
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            {onBack && (
              <button
                className="back-button-header mr-3" 
                onClick={onBack}
                style={{ padding: 0, border: 'none', background: 'transparent' }}
              >
                <img src={BackButton} alt="Back" />
              </button>
            )}
            <h4 className="listing-page-title mb-0" style={{ fontWeight: 'bold' }}>
              Listing Optimizer
            </h4>
          </div>

          <div className="d-flex align-items-center">
            <Button className="btn-background-color-action-settings mr-3" 
            onClick={handleDownload}
            disabled={loading}>
              <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: '17px', marginRight: '10px' }} icon={faDownload} />
              {loading ? "Processing..." : "Download Catalog"}
            </Button>
            {/* <Button className="btn-send-approval mr-3" disabled={!previewMode}>Update</Button> */}
            <Button  onClick={handleHistory}  className="btn-background-color-Proceed-gallery">History</Button>
          </div>
        </div>
        
        <div className="amazon-listing-header-card mb-3 w-100 d-flex justify-content-between align-items-center">
          <span><span><b>ASIN : </b></span>{displayAsin}</span>
          <span><span><b>Store Name : </b></span>{storeDetails.name}</span>
          <span><span><b>SKU : </b></span>{sku}</span>
          <span><span><b>Type : </b></span>{productType}</span>
        </div>

        {/* <div className={`summary-collapsible mb-3 ${isScrolled ? "hidden" : ""}`}>
          <AmazonProductListingSummaryBar summary={data && data.summary} />
        </div> */}
        
        <div className="d-flex justify-content-between align-items-center">
          <div className="flex-grow-1">
            <AmazonProductListingTabs 
              tabs={tabs} 
              activeTab={activeTab} 
              setActiveTab={setActiveTab} 
              search={search}
              setSearch={setSearch}
              previewMode={previewMode}
            />
          </div>
          <div className="d-flex align-items-center ml-4 mr-2">
            <span className="custom-label mr-2" style={{ fontWeight: '500' }}>Review :</span>
            <label className="toggle-switch mb-0">
              <input type="checkbox" checked={previewMode} onChange={handlePreviewMode} />
              <span className="dot"></span>
            </label>
          </div>
        </div>
      </div>

      <div className="scrollable-content">
        {filtered.length === 0 ? (
          <div className="empty-state p-3 text-center">No fields found.</div>
        ) : previewMode ? (
          <AmazonProductListingPreview 
          groupedFields={grouped} 
          changedFields={changedFields} 
          storeName={storeDetails && storeDetails.name ? storeDetails.name : "Store"}
          asin={displayAsin}
          sku={sku}
          />
        ) : (
          Object.keys(grouped).map(group => (
            <AmazonProductListingGroupSection 
              key={group} 
              title={group} 
              fields={grouped[group]} 
              setFields={setFields} 
              data={data} 
              onFieldChange={handleFieldChange}
              errorFields={errorFields} 
              changedFields={changedFields}
            />
          ))
        )}
      </div>

      <div className="listing-page-actions d-flex justify-content-end align-items-end mt-4 mb-4">
        <Button onClick={handleSave} className="btn-background-color-Proceed-gallery" disabled={saving}>
          {saving ? 'Validating...' : 'Validate'}
        </Button>
        {/* <Button onClick={handleAutoFix} className="btn-secondary ml-3">Auto Fix</Button> */}
      </div>

      <CustomModal
        header={saveModalData && saveModalData.issues && saveModalData.issues.length > 0 ? "Validation Report" : "Save Status"}
        isOpen={isSaveModalOpen}
        toggle={() => setIsSaveModalOpen(!isSaveModalOpen)}
        size={"lg"} 
        className="curve-popup"
      >
        <div className="p-3" style={{ minHeight: '150px' }}>
        <div className="d-flex justify-content-end mr-4">
            <Button 
              className="btn-send-approval" 
              disabled={!isListingValid}
            >
              Update Listing
            </Button>
          </div>
          
          {saveModalData && saveModalData.type === "WARNING" ? (
            <div className="text-warning fw-bold fs-5 text-center mt-4">
              {saveModalData.message}
            </div>
            
          ) : saveModalData ? (
            <>
              <AmazonProductListingUpdatePopup data={saveModalData} />
              
              {saveModalData.updated_fields && saveModalData.updated_fields.length > 0 && (
                <div className="mt-3 mx-4 mb-2 p-3 rounded" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                  <h6 className="text-dark fw-bold" style={{ fontSize: '14px' }}>Updated Values:</h6>
                  <ul className="text-dark mb-0" style={{ paddingLeft: '20px', fontSize: '13px' }}>
                    {saveModalData.updated_fields.map((f, idx) => (
                      <li key={idx}><strong>{f.field}:</strong> {f.value}</li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          ) : null}
        </div>
      </CustomModal>
      <CustomModal
        isOpen={isHistoryModalOpen}
        toggle={() => setIsHistoryModalOpen(!isHistoryModalOpen)}
        size="xl"
        className="curve-popup"
        header="Amazon Listing History"
      >
        <div className="p-3">
          <ReactTable
            data={historyData}
            columns={historyColumns}
            className="-fixed -highlight -striped mt-2"
            getTheadProps={() => {
              return {
                style: {
                  overflowY: "hidden",
                  background: "#B1FA63",
                  color: "#243837",
                },
              };
            }}
            defaultPageSize={5}
            noDataText={"No History Data Found."}
          />
        </div>
      </CustomModal>
    </div>
  );
}

const mapStateToProps = (state) => ({ token: state.loggedUser.token });
export default connect(mapStateToProps)(AmazonProductListingMainPage);